import { string } from 'yup';
import { HelpOutline, AttachFileOutlined, ScatterPlot } from '@mui/icons-material';
import { QueryKey } from '@tanstack/query-core';

import { Environment } from '@playq/octopus-common';
import { AccessLevel } from '@playq/octopus2-auth';

import { BeetleLookupItems, Colors } from './IssuesSupportRequests/types';
import { UpdateRequestType } from './IssuesSupportRequests/components/tables/types';
import { SupportContentType } from './types';

export const audienceQueryKeys: QueryKey = ['service', 'audience', 'support'];
export const audienceRetrieveQueryKeys: QueryKey = ['retrieve'];
export const issueKeys: QueryKey = [...audienceQueryKeys, 'query', 'issues'];
export const issueAttachmentKeys: QueryKey = [...audienceQueryKeys, 'query', 'issue_attachment'];
export const requestsAttachmentKeys: QueryKey = [...audienceQueryKeys, 'query', 'requests_attachment'];
export const requestsKeys: QueryKey = [...audienceQueryKeys, 'query', 'supportRequests'];

export const initialEnv = Environment.Live;

export const requiredErrorMessage = 'This field is required';
export const guidErrorMessage = 'Field expects GUID format';

export const updateRequestTitles = Object.values(UpdateRequestType);

export const updateRequestTitlesObject: { [key in UpdateRequestType]: string } = {
  [UpdateRequestType.Accepted]: 'Accepted',
  [UpdateRequestType.Declined]: 'Declined',
  [UpdateRequestType.BeingProcessed]: 'Being Processed',
  [UpdateRequestType.Resolved]: 'Resolved',
  [UpdateRequestType.Sent]: 'Sent',
};

export const unresolveIssue = 'Unresolve';

const notesSchema = string().trim().required('Note text is required');

export const notesDialogOptions = {
  placeholder: 'Type the note you want to add',
  schema: notesSchema,
  title: 'Note editor',
};

export const statusFilterData = ['RESOLVED', 'NOT RESOLVED'];

const attachments = {
  tooltipTitle: 'Go to Attachments',
  color: Colors.INFO,
  title: 'Attachments',
  type: SupportContentType.ATTACHMENTS,
  icon: AttachFileOutlined,
};
export const beetleLookupItems: BeetleLookupItems[] = [
  {
    tooltipTitle: 'Go to Support Requests',
    color: Colors.PRIMARY,
    title: 'Support Requests',
    type: SupportContentType.SUPPORT_REQUESTS,
    icon: HelpOutline,
    attachments: {
      ...attachments,
      tooltipTitle: 'Go to Support Requests Attachments',
      type: SupportContentType.SUPPORT_REQUESTS_ATTACHMENTS,
    },
  },
  {
    tooltipTitle: 'Go to Issues',
    color: Colors.SECONDARY,
    title: 'Issues',
    type: SupportContentType.ISSUES,
    icon: HelpOutline,
    attachments: {
      ...attachments,
      tooltipTitle: 'Go to Issues Attachments',
      type: SupportContentType.ISSUES_ATTACHMENTS,
    },
  },
  {
    ...attachments,
  },
  {
    tooltipTitle: 'Go to Clusterization',
    color: Colors.PRIMARY,
    title: 'Clusterization',
    type: SupportContentType.TASKS,
    icon: ScatterPlot,
    accessLevel: AccessLevel.None,
  },
];

export const COLUMN_HIDDEN = ['Notes', 'ID', 'Author'];
export const ISSUES_CACHE_KEY = 'issues_table_key';
export const REQUESTS_CACHE_KEY = 'requests_table_key';
